export default __webpack_public_path__ + "static/sgLandmarksPoster-bc69a1daa35926865b590d9fbececf6a.jpg";